import FR from './translations/fr' // Using it as typing

export const LANG = ['fr', 'en'] as const
export type TLanguage = (typeof LANG)[number]
export type Translation = Record<keyof ReturnType<typeof FR>, string>

export interface ITranslationContext {
    translations: Translation

    language: TLanguage
    setLanguage: (language: TLanguage) => void
}
